import RemoteMeetings from "@/views/App/Portal/CaseManagementCoaching/RemoteDigitalSignature/RemoteMeetings.vue";


const routesPortalCaseManagementCoachingRemoteSignature = [
    {
        path: 'case-management-coaching/remote-meetings/:token',
        name: 'cmcRemoteMeetings',
        component: RemoteMeetings,
        meta: {
            public: true
        }
    },
];

export default routesPortalCaseManagementCoachingRemoteSignature;